import ProductAnalytics from "./ProductAnalytics";

const productAnalytics = {
    1: ProductAnalytics
};

export default productAnalytics;